"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.put = void 0;
const validation_1 = __importDefault(require("../../../../../validation"));
const rules_1 = __importDefault(require("../../../../../validation/rules"));
const newPutBodyRules = {
    privacyIssues: rules_1.default.object().test('valid-answers-object', 'Invalid answers object structure', obj => {
        if (!obj)
            return false;
        return Object.values(obj).every(value => {
            if (!value || typeof value !== 'object')
                return false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (!Array.isArray(value.answers))
                return false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return value.answers.every((answer) => typeof answer === 'string');
        });
    }),
};
const putParamRules = {
    id: validation_1.default.rules.string().required().label('Organization ID'),
    productId: validation_1.default.rules.string().required().label('Product ID'),
};
const putParams = {
    rules: putParamRules,
    schema: validation_1.default.schema(putParamRules),
};
const putBody = {
    rules: newPutBodyRules,
    schema: validation_1.default.schema(newPutBodyRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.put = {
    body: putBody,
    params: putParams,
};
exports.get = { params: putParams };
